import { Briefcase, Globe, Heart, Home, Music, ShoppingBag } from "lucide-react";

const data = [
    {
      id: 1,
      icon: Home,
      title: "Home Sweet Home",
      description: "Find comfort and peace in your own space with our premium home solutions."
    },
    {
      id: 2,
      icon: Briefcase,
      title: "Work Smart",
      description: "Enhance productivity with the best tools and strategies for a successful career."
    },
    {
      id: 3,
      icon: ShoppingBag,
      title: "Shop With Ease",
      description: "Get the best deals on quality products, delivered right to your doorstep."
    },
    {
      id: 4,
      icon: Heart,
      title: "Healthy Living",
      description: "Stay fit and happy with our expert health and wellness tips."
    },
    {
      id: 5,
      icon: Globe,
      title: "Explore the World",
      description: "Discover new places and adventures with our top travel recommendations."
    },
    {
      id: 6,
      icon: Music,
      title: "Feel the Beat",
      description: "Immerse yourself in the rhythm of life with the latest and greatest music trends."
    }
  ];
  
  export default data;